import { createStyles, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useLocalization } from "../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    mainWrapper: {
      display: 'flex',
      justifyContent: 'space-around',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%'
    },
    loaderWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'column',
      maxWidth: 500,
      margin: '.5em 0 .6em 0'
    },
    typography: {
      marginTop: '1rem',
      fontWeight: 'bolder'
    }
  });
});
export const DocumentViewerLoading = props => {
  const classes = useStyles();
  const localization = useLocalization();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.mainWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: props.image,
    alt: "Loader"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "textSecondary",
    align: "center",
    className: classes.typography
  }, localization.loadingDocument)));
};
//# sourceMappingURL=document-viewer-loading.js.map